export default function TooltipIcon(props) {
  return (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='#4985FA' {...props}>
      <path d='M9.20829 9.20834H7.79163V4.95834H9.20829V9.20834ZM9.20829 12.0417H7.79163V10.625H9.20829V12.0417ZM8.49996 1.41667C4.58794 1.41667 1.41663 4.58799 1.41663 8.50001C1.41663 10.3786 2.1629 12.1803 3.49129 13.5087C4.81967 14.8371 6.62134 15.5833 8.49996 15.5833C10.3786 15.5833 12.1803 14.8371 13.5086 13.5087C14.837 12.1803 15.5833 10.3786 15.5833 8.50001C15.5833 6.62139 14.837 4.81972 13.5086 3.49133C12.1803 2.16295 10.3786 1.41667 8.49996 1.41667Z' />
    </svg>
  )
}
